export default "__VITE_ASSET__BIpnqd3h__"